'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import PiggyBankIcon from '@/Icons/PiggyBank'
import GiftCardIcon  from '@/Icons/GiftCard'
import PromoIcon     from '@/Icons/Promo'

import NewPartnersNotifications from '@/NewPartnersNotifications'
import getFormStatus            from '@/Form/Functions/getFormStatus'

import Link from '@Pure/Link'

import bemit from '@function/bemit'

let app = window.app;

export default class ECPartnersSpacePage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange({ source: 'DidMount' });
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = ({ source, data }) =>
	{
		const component = this, props = this.props, state = this.state;

		const permissions = app.state.session?.permissions || { };

		if (!permissions.title || permissions.title === 'not_auth') return;

		component.setState({ permissions: permissions });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const permissions = state.permissions || { };

		const is__admin = permissions.title === 'Membre de synergies';

		const can_access_partners = is__admin ? true : [true, 'true']
		.includes(permissions.access_partners);

		const content = can_access_partners ?
		(
			<div className="o-grid-2 u-flex home-grids">

				<div className="o-grid__item">

					<div className={ bemit('c-color-block',
						['img', 'partner-page']) }>

						<PiggyBankIcon className="o-inline-icon
							c-color-block__icon"
						/>

						<div className="c-color-block__content">
							<div className="c-color-block__title">
								Avec ma carte SYNERGIES
							</div>
						</div>

						<Link className="c-color-block__link"
							href="/accueil/espace-partenaires/partenaires"
						/>

					</div>

					<div className="c-color-block__description">
						Pour plus de pouvoir d’achat&nbsp;: des réductions directement en caisse et/ou des codes promo.
						<br />
						Découvrez ici les avantages auprès de notre réseau de partenaires locaux.
					</div>

					<NewPartnersNotifications />

				</div>

				<div className="o-grid__item">

					<div className={ bemit('c-color-block',
						['img', 'bons']) }>

						<GiftCardIcon className="o-inline-icon
							c-color-block__icon"
						/>

						<div className="c-color-block__content">
							<div className="c-color-block__title">
								Bons d'achat
							</div>
						</div>

						<Link className="c-color-block__link"
							href="/accueil/espace-partenaires/bons-d-achat"
						/>

					</div>

					<div className="c-color-block__description">
						Commandez en ligne vos bons d’achat à tarif réduit (jusqu’à 15%).
						<br />
						Vous utilisez ensuite ces cartes prépayées pour régler vos achats en caisse.
						<br />
						<br />
						Exemple&nbsp;: vous achetez une carte 95&nbsp;€ et elle a une valeur de 100&nbsp;€ en caisse du magasin.
					</div>

					<div className="u-full-width"
						style={ { position: 'relative', marginTop: 30 } }>

						<div className={ bemit('c-color-block',
							['img', 'promos']) }>

							<PromoIcon className="o-inline-icon
								c-color-block__icon"
							/>

							<div className="c-color-block__content">
								<div className="c-color-block__title">
									Codes Promo
								</div>
							</div>

							<Link className="c-color-block__link"
								href="/accueil/espace-partenaires/codes-promotionnels"
							/>

						</div>

						<div className="c-color-block__description">
							<strong>Augmentez votre pouvoir d'achat en ligne</strong> et économisez toute l'année grâce à des codes promo négociés par Synergies.
						</div>

					</div>

				</div>

			</div>
		)
		: getFormStatus(
		{
			warning: 'Votre CSE n\'a pas accès à l\'espace partenaires.'
		});

		const output =
		(
			<Layout history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					{ content }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}